module.exports = __webpack_public_path__ + "static/media/at03.d998a8ce.jpg";